// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import radium from 'radium';
import { Col } from 'react-bootstrap/lib';
import styler from 'react-styling';
import lang from 'lodash/lang';
import array from 'lodash/array';
import { observer } from 'mobx-react';
import NotificationSystem from 'react-notification-system';
// import _ from 'lodash';

import { filterNotNullEdgeNodes } from '../libs/Extract';
import TextFilter from '../Components/TextFilter';
import ListFilter from '../Components/ListFilter';
import ProtectedResourcesTabs from '../Components/Protected/ProtectedResourcesTabs';
import { CONTACTS_PAGE_SIZE, MEETINGROOMS_PAGE_SIZE, OTHERRESOURCES_PAGE_SIZE } from '../../../config';
import ResourcesTabs from '../Components/ResourcesTabs';
import breakpoints from '../../css/breakpoints';
import { uiStateStoreInstance } from '../Stores/UIStateStore';
import ClassifyResourcesMutation from '../Mutations/ClassifyResourcesMutation';
import { logError } from '../libs/Logger';
import { removeLocalStorageItem } from '../libs/LocalStorage';

const style = styler `
    FilterWrap
      margin-left: 10px
      @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
        margin-left: 0px
    Filters
      position: fixed
      z-index: 100
      background: #FFF
      width: 100%
      box-shadow: 0 0 20px #E6E6E6
      -webkit-box-shadow: 0 0 20px #E6E6E6
    Divider
      height: 40px
    Line
      border-color: #D3D3D3
      display: inline-block
      width: calc(100% - 60px)
      float: right
      margin-right: 20px
    Letter
      color: #A8A8A8
      padding-left: 20px
      float: left
      font-size: 14px
      margin-top: 9px
    Toolbar
      padding: 15px 5px 0 15px
      @media screen and (max-width: ${breakpoints.MEDIUM_AND_ABOVE}px)
        margin-top: 2px
    Searchfield
      padding: 0 10px 0 0
  `;

let contactPageSize = CONTACTS_PAGE_SIZE;
let meetingRoomsPageSize = MEETINGROOMS_PAGE_SIZE;
let otherResourcesPageSize = OTHERRESOURCES_PAGE_SIZE;

type Props = {
  mode: string,
  selectedContactEmail?: string,
  toggleItem: Function,
  selectedContact?: string,
  viewer: any,
  messages: Object,
  contactEmail: string,
  relay: Object,
  defaultTab: string,
  languagedata: Object,
}

let previousLetter;
function letterNew(contactsList, value, index) {
  if (contactsList[index] !== undefined) {
    const thisLetter = value.displayName.charAt(0);
    if (thisLetter !== previousLetter) {
      previousLetter = thisLetter;
      return (
        <div style={style.Divider}>
          <span style={style.Letter}>{thisLetter}</span>
          <hr style={style.Line} />
        </div>
      );
    }
  }
  return null;
}


@observer
export class ListContainer extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      searchText: '',
      selectedCity: '',
      selectedDepartment: '',
      selectedLocation: '',
      selectedCompany: '',
      pageStart: 0,
      hasMoreContact: true,
      hasMoreMeetingRooms: true,
      hasMoreOtherResources: true,
      selectedTab: props.defaultTab,
      mode: props.mode,
    };
  }
  state: {
    searchText: string,
    selectedCity: string,
    selectedDepartment: string,
    selectedLocation: string,
    selectedCompany: string,
    pageStart: number,
    hasMoreContact: boolean,
    hasMoreMeetingRooms: boolean,
    hasMoreOtherResources: boolean,
    selectedTab: string,
    mode: string,
  }

  componentWillMount() {
    // empty emails and ids store observable arrays
    // this needed in case user select all resources in scheduler view and switched to admin view without unchecking the previous selection
    this._unsetStoreEmailsAndIds();
  }

  componentWillReceiveProps(nextProps: Object) {
    if (this.props.defaultTab !== nextProps.defaultTab) {
      this.setState({
        selectedTab: nextProps.defaultTab,
      });
    }
  }

  _notificationSystem: any

  decideType(type: string, adminMode: boolean) {
    if (adminMode) {
      uiStateStoreInstance.setShowMeetingRoom(false);
      uiStateStoreInstance.setShowOtherResource(false);
      return;
    }
    if (type === 'contact') {
      uiStateStoreInstance.setShowMeetingRoom(false);
      uiStateStoreInstance.setShowOtherResource(false);
    } else if (type === 'meetingRoom') {
      uiStateStoreInstance.setShowMeetingRoom(true);
      uiStateStoreInstance.setShowOtherResource(false);
    } else {
      uiStateStoreInstance.setShowMeetingRoom(false);
      uiStateStoreInstance.setShowOtherResource(true);
    }
  }
  _setStoreEmailsAndIds = (resourcesIds: Array<string>, resourcesEmails: Array<string>, type: string) => {
    if (type === 'contact') {
      uiStateStoreInstance.contactIds = resourcesIds;
      uiStateStoreInstance.contactEmails = resourcesEmails;
    } else if (type === 'meetingRoom') {
      uiStateStoreInstance.meetingRoomIds = resourcesIds;
      uiStateStoreInstance.meetingRoomEmails = resourcesEmails;
    } else {
      uiStateStoreInstance.otherResourcesIds = resourcesIds;
      uiStateStoreInstance.otherResourcesEmails = resourcesEmails;
    }
  }

  _unsetStoreEmailsAndIds = (type: ?string) => {
    if (!type) {
      uiStateStoreInstance.contactIds = null;
      uiStateStoreInstance.contactEmails = null;
      uiStateStoreInstance.meetingRoomIds = null;
      uiStateStoreInstance.meetingRoomEmails = null;
      uiStateStoreInstance.otherResourcesIds = null;
      uiStateStoreInstance.otherResourcesEmails = null;
    }
    if (type === 'contact') {
      uiStateStoreInstance.contactIds = null;
      uiStateStoreInstance.contactEmails = null;
    } else if (type === 'meetingRoom') {
      uiStateStoreInstance.meetingRoomIds = null;
      uiStateStoreInstance.meetingRoomEmails = null;
    } else {
      uiStateStoreInstance.otherResourcesIds = null;
      uiStateStoreInstance.otherResourcesEmails = null;
    }
  }

  _getMergedEmails = () => {
    let mergedEmails = [];

    // merge emails array of all types
    const contactEmails = uiStateStoreInstance.contactEmails;
    const meetingRoomEmails = uiStateStoreInstance.meetingRoomEmails;
    const otherResourcesEmails = uiStateStoreInstance.otherResourcesEmails;

    if (contactEmails) {
      mergedEmails = [...mergedEmails, ...contactEmails.slice()];
    }
    if (meetingRoomEmails) {
      mergedEmails = [...mergedEmails, ...meetingRoomEmails.slice()];
    }
    if (otherResourcesEmails) {
      mergedEmails = [...mergedEmails, ...otherResourcesEmails.slice()];
    }

    return mergedEmails;
  }

  _getMergedIds= () => {
    let mergedIds = [];

    // merge ids array of all types
    const contactIds = uiStateStoreInstance.contactIds;
    const meetingRoomIds = uiStateStoreInstance.meetingRoomIds;
    const otherResourcesIds = uiStateStoreInstance.otherResourcesIds;

    if (contactIds) {
      mergedIds = [...mergedIds, ...contactIds.slice()];
    }
    if (meetingRoomIds) {
      mergedIds = [...mergedIds, ...meetingRoomIds.slice()];
    }
    if (otherResourcesIds) {
      mergedIds = [...mergedIds, ...otherResourcesIds.slice()];
    }

    return mergedIds;
  }
  _handleAllSelection = (resources: Array<any>, checked: boolean, type: string) => {
    let resourcesEmails = [];
    const resourcesIds = [];

    resources.map(resource => {
      resourcesEmails.push(resource.email);
      resourcesIds.push(resource.id);
      return { resourcesEmails, resourcesIds };
    });

    if (!checked) {
      // set emails to manipulate the view
      const newEmailArray = array.without(uiStateStoreInstance.emails, ...resourcesEmails);
      uiStateStoreInstance.setEmails(newEmailArray);
      // set ids to classify resources in case of admin mode
      const newIdsArray = array.without(uiStateStoreInstance.ids, ...resourcesIds);
      uiStateStoreInstance.ids = newIdsArray;
      // reset store emails and ids array of all types
      this._unsetStoreEmailsAndIds(type);
      // empty scheduler emails from local storage
      removeLocalStorageItem('scheduler');
      // update the view with new selection
      this.props.toggleItem('remove');
      return;
    }

    // remove null values this is a hack becuase some otherResource has email of null
    resourcesEmails = array.without(resourcesEmails, null);
    // add ids and emails of specific type (contacts, meetingrooms, otherReources) to UI store observable
    this._setStoreEmailsAndIds(resourcesIds, resourcesEmails, type);
    // set store emails array
    const mergedEmails = this._getMergedEmails();
    uiStateStoreInstance.setEmails(mergedEmails);
    // set store ids array
    const mergedIds = this._getMergedIds();
    uiStateStoreInstance.ids = mergedIds;

    this.props.toggleItem();
  }

  _handleContactMultiSelection = (contactEmail: string, type: string, contactId: string) => {
    // add/remove resources id from array
    if (uiStateStoreInstance.ids.includes(contactId)) {
      array.remove(uiStateStoreInstance.ids, id =>
        id === contactId
      );
    } else if (typeof contactId !== 'undefined') { // checkbox onChange trigger twice -> new design
      uiStateStoreInstance.ids.push(contactId);
    }

    let { selectedContact } = this.props;
    selectedContact = selectedContact.slice();
    let newEmails = array.without(selectedContact, null);
    // remove resources email from array if exist
    if (this.props.selectedContact.includes(contactEmail)) {
      const relayVarsEmails = lang.clone(selectedContact);
      array.remove(relayVarsEmails, emails =>
        emails === contactEmail
      );
      uiStateStoreInstance.setEmails(relayVarsEmails);
      this.decideType(type, uiStateStoreInstance.adminMode);
      this.props.toggleItem('remove');
      return;
    }
    newEmails = [...newEmails, contactEmail];
    // set store state/observable
    uiStateStoreInstance.setEmails(newEmails);

    this.decideType(type, uiStateStoreInstance.adminMode);
    this.props.toggleItem();
  }

  _handleContactSingleSelection = (contactEmail: string, type: string) => {
    this.decideType(type, uiStateStoreInstance.adminMode);
    uiStateStoreInstance.setSelectedContactEmail(contactEmail);
    uiStateStoreInstance.setEmails(contactEmail);
    this.props.toggleItem(type);
  }

  _loadMore = (dataType: string) => {
    const contactHasNextPage = this.props.viewer.contacts.pageInfo.hasNextPage;
    const meetingroomsHasNextPage = this.props.viewer.meetingRooms.pageInfo.hasNextPage;
    const otherResourcesHasNextPage = this.props.viewer.otherResources.pageInfo.hasNextPage;
    if (dataType === 'contacts') {
      contactPageSize += CONTACTS_PAGE_SIZE;
    } else if (dataType === 'meetingrooms') {
      meetingRoomsPageSize += MEETINGROOMS_PAGE_SIZE;
    } else {
      otherResourcesPageSize += OTHERRESOURCES_PAGE_SIZE;
    }
    this.props.relay.setVariables({
      contactPageSize,
      meetingRoomsPageSize,
      otherResourcesPageSize,
    }, readyState => {
      if (readyState.done || readyState.aborted) {
        this.setState({
          hasMoreContact: contactHasNextPage,
          hasMoreMeetingRooms: meetingroomsHasNextPage,
          hasMoreOtherResources: otherResourcesHasNextPage,
        });
      } else if (readyState.error) {
        this.setState({
          hasMoreContact: false,
          hasMoreMeetingRooms: false,
          hasMoreOtherResources: false,
        });
      }
    });
  }
  _searchHandleTextIput = (event: Object) => {
    let searchText = '';
    if (event && event.target.value) {
      searchText = event.target.value.toLowerCase();
    }

    this.setState({ searchText });
    this.props.relay.setVariables({
      textFilter: searchText === '' ? null : searchText,
    });
  }

  _changeSelectedCity = (elm: Object) => {
    let selectedCity = '';
    if (elm) {
      selectedCity = elm.value;
    }

    this.props.relay.setVariables({
      cityFilter: selectedCity,
    }, readyState => {
      if (readyState.done || readyState.aborted) {
        this.setState({ selectedCity });
      }
    });
  }

  _changeSelectedDepartment = (elm: Object) => {
    let selectedDepartment = '';
    if (elm) {
      selectedDepartment = elm.value;
    }

    this.props.relay.setVariables({
      departmentFilter: selectedDepartment,
    }, readyState => {
      if (readyState.done || readyState.aborted) {
        this.setState({ selectedDepartment });
      }
    });
  }

  _changeSelectedLocation= (elm: Object) => {
    let selectedLocation = '';
    if (elm) {
      selectedLocation = elm.value;
    }

    this.props.relay.setVariables({
      locationFilter: selectedLocation,
    }, readyState => {
      if (readyState.done || readyState.aborted) {
        this.setState({ selectedLocation });
      }
    });
  }

  _changeSelectedCompany= (elm: Object) => {
    let selectedCompany = '';
    if (elm) {
      selectedCompany = elm.value;
    }

    this.props.relay.setVariables({
      companyFilter: selectedCompany,
    }, readyState => {
      if (readyState.done || readyState.aborted) {
        this.setState({ selectedCompany });
      }
    });
  }

  _handleSelect = (key: number) => {
    const state = {
      selectedLocation: '',
      searchText: '',
      selectedCity: '',
      selectedDepartment: '',
    };

    this.props.relay.setVariables({
      locationFilter: null,
      textFilter: null,
      cityFilter: null,
      departmentFilter: null,
      companyFilter: null,
    }, readyState => {
      if (readyState.done || readyState.aborted) {
        if (key === 2) {
          this.setState({
            ...state,
            selectedTab: 'meetingrooms',
          });
        } else if (key === 1) {
          this.setState({
            ...state,
            selectedTab: 'contacts',
          });
        } else {
          this.setState({
            ...state,
            selectedTab: 'resources',
          });
        }
      }
    });
  }

  _toggleAdminMode = () => {
    // uncheck select all check box
    uiStateStoreInstance.isAllSelected = false;
    // reset emails and ids arrays
    uiStateStoreInstance.emails = [];
    uiStateStoreInstance.ids = [];
    // empty scheduler emails from local storage
    removeLocalStorageItem('scheduler');
    uiStateStoreInstance.setAdminMode(!uiStateStoreInstance.adminMode);
    const mode = uiStateStoreInstance.adminMode ? 'multi' : 'single';
    this.setState({
      mode,
    });
  }

  _handleClassification = (type: string) => {
    if (uiStateStoreInstance.ids.slice().length === 0) {
      return;
    }
    this.props.relay.commitUpdate(
      new ClassifyResourcesMutation({
        targetType: type,
        resources: uiStateStoreInstance.ids.slice(),
      }),
      {
        onSuccess: (successPayload) => {
          this.props.relay.forceFetch();
          // upate resources id's in the state store with new id's after mutation
          uiStateStoreInstance.ids = [];
          if (type === 'MeetingRoom') {
            successPayload.classifyResources.meetingRooms.forEach(room => {
              uiStateStoreInstance.ids.push(room.id);
            });
          } else if (type === 'Contact') {
            successPayload.classifyResources.contacts.forEach(contact => {
              uiStateStoreInstance.ids.push(contact.id);
            });
          } else {
            successPayload.classifyResources.otherResources.forEach(resource => {
              uiStateStoreInstance.ids.push(resource.id);
            });
          }
          uiStateStoreInstance.showNotification(this._notificationSystem, this.props.languagedata.classification_success, 'success', 'tc', 5);
        },
        onFailure: (error) => {
          logError(error);
          uiStateStoreInstance.showNotification(this._notificationSystem, this.props.languagedata.classification_failure, 'error', 'tc', 5);
        },
      }
    );
  }

  render() {
    let defaultTab;
    if (this.state.selectedTab === 'meetingrooms') {
      defaultTab = 2;
    } else if (this.state.selectedTab === 'resources') {
      defaultTab = 3;
    } else {
      defaultTab = 1;
    }
    const meetingRoomList = filterNotNullEdgeNodes(this.props.viewer.meetingRooms);
    const contactList = filterNotNullEdgeNodes(this.props.viewer.contacts);
    const otherResourcesList = filterNotNullEdgeNodes(this.props.viewer.otherResources);
    // decide the source of filters options
    let departments;
    let cities;
    let locations;
    let companies;

    if (this.state.selectedTab === 'resources') {
      departments = this.props.viewer.otherResources.filters.departments;
      cities = this.props.viewer.otherResources.filters.cities;
      locations = this.props.viewer.otherResources.filters.locations;
      companies = this.props.viewer.otherResources.filters.companies;
    } else if (this.state.selectedTab === 'meetingrooms') {
      locations = this.props.viewer.meetingRooms.filters.locations;
      companies = this.props.viewer.meetingRooms.filters.companies;
    } else {
      departments = this.props.viewer.contacts.filters.departments;
      cities = this.props.viewer.contacts.filters.cities;
      companies = this.props.viewer.contacts.filters.companies;
      locations = this.props.viewer.contacts.filters.locations;
    }

    let selectedContactEmail;
    if (this.props.selectedContactEmail === null) {
      selectedContactEmail = this.props.contactEmail;
    } else {
      selectedContactEmail = this.props.selectedContactEmail;
    }

    return (
      <div style={style.FilterWrap}>
        <div style={style.Filters}>
          <div style={style.Toolbar}>
            <Col xs={12} sm={3} md={2} style={style.Searchfield}>
              <TextFilter
                searchPlaceholder={this.props.messages.search}
                searchHandleTextIput={this._searchHandleTextIput}
                debounce={300}
                value={this.state.searchText}
                id="search"
              />
            </Col>
            {companies && companies.length !== 0 ?
              <Col xs={3} md={2} style={style.Searchfield} className="hidden-xs">
                <ListFilter
                  placeholder={this.props.messages.select_company}
                  options={companies.map(d => ({
                    value: d,
                    label: d,
                  }))}
                  onChange={this._changeSelectedCompany}
                  value={this.state.selectedCompany}
                />
              </Col>
            : null }
            {cities && cities.length !== 0 ?
              <Col xs={3} md={2} style={style.Searchfield} className="hidden-xs">
                <ListFilter
                  placeholder={this.props.messages.select_city}
                  options={cities.map(d => ({
                    value: d,
                    label: d,
                  }))}
                  onChange={this._changeSelectedCity}
                  value={this.state.selectedCity}
                />
              </Col>
            : null }
            {departments && departments.length !== 0 ?
              <Col xs={3} md={2} style={style.Searchfield} className="hidden-xs">
                <ListFilter
                  placeholder={this.props.messages.select_department}
                  options={departments.map(d => ({
                    value: d,
                    label: d,
                  }))}
                  onChange={this._changeSelectedDepartment}
                  value={this.state.selectedDepartment}
                />
              </Col>
            : null }
            {locations && locations.length !== 0 ?
              <Col xs={3} md={2} style={style.Searchfield} className="hidden-xs">
                <ListFilter
                  placeholder={this.props.messages.select_location}
                  options={locations.map(d => ({
                    value: d,
                    label: d,
                  }))}
                  onChange={this._changeSelectedLocation}
                  value={this.state.selectedLocation}
                />
              </Col>
            : null }
          </div>
        </div>
        <ResourcesTabs
          defaultTab={defaultTab}
          handleSelect={this._handleSelect}
          languagedata={this.props.languagedata}
          mode={this.state.mode}
          contactList={contactList}
          meetingRoomList={meetingRoomList}
          otherResourcesList={otherResourcesList}
          letterNew={letterNew}
          selectedContactEmail={selectedContactEmail}
          selectedContact={this.props.selectedContact}
          hasMoreContact={this.state.hasMoreContact}
          hasMoreMeetingRooms={this.state.hasMoreMeetingRooms}
          hasMoreOtherResources={this.state.hasMoreOtherResources}
          loadMore={this._loadMore}
          toggleAdminMode={this._toggleAdminMode}
          handleContactSingleSelection={this._handleContactSingleSelection}
          handleContactMultiSelection={this._handleContactMultiSelection}
          handleClassification={this._handleClassification}
          handleAllSelection={this._handleAllSelection}
          protectedComponent={ProtectedResourcesTabs}
        />
        <NotificationSystem ref={(element) => { this._notificationSystem = element; }} />
      </div>);
  }
}

export default Relay.createContainer(radium(ListContainer), {
  initialVariables: {
    contactPageSize,
    meetingRoomsPageSize,
    otherResourcesPageSize,
    departmentFilter: null,
    cityFilter: null,
    textFilter: null,
    locationFilter: null,
    companyFilter: null,
  },
  prepareVariables: vars => {
    const departmentFilter = vars.departmentFilter === '' || !vars.departmentFilter ?
      null : vars.departmentFilter;
    const cityFilter = vars.cityFilter === '' || !vars.cityFilter ?
      null : vars.cityFilter;
    const locationFilter = vars.locationFilter === '' || !vars.locationFilter ?
      null : vars.locationFilter;
    const companyFilter = vars.companyFilter === '' || !vars.companyFilter ?
      null : vars.companyFilter;
    const preparedVars = {
      ...vars,
      departmentFilter,
      cityFilter,
      locationFilter,
      companyFilter,
    };
    return preparedVars;
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        contacts(first: $contactPageSize, department: $departmentFilter, city: $cityFilter, text: $textFilter, company: $companyFilter, location: $locationFilter) {
          edges {
            node {
              id
              displayName
              email
              city
              department
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          filters {
            cities
            departments
            companies
            locations
          }
        }
        meetingRooms(first: $meetingRoomsPageSize, location: $locationFilter, text: $textFilter, company: $companyFilter) {
          edges {
            node {
              id
              displayName
              email
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          filters {
            locations
            companies
          }
        }
        otherResources(first: $otherResourcesPageSize, location: $locationFilter, text: $textFilter, department: $departmentFilter, city: $cityFilter, company: $companyFilter) {
          edges {
            node {
              id
              displayName
              email
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          filters {
            locations
            cities
            departments
            companies
          }
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Containers/ListContainer.js